import { ActionTree } from 'vuex'
import { State } from '.'
import { IEntity } from '../interfaces/entity.interface'

const actions: ActionTree<State, any> = {
	setEntity({ state, commit }, payload: IEntity) {
		commit('setEntity', payload)
		commit('setBackupEntity', payload)
	},
	updateEntity({ state, commit }, payload: { [key: string]: any }) {
		const entity = JSON.parse(JSON.stringify (state.entity))
		
		if (entity) {
			[...Object.keys(payload)].forEach((key: string) => {
				if (key !== 'type') entity[key] = payload[key]
			})
		}

		commit('updateEntity', entity)
	},
	setQuestions({ state, commit }, payload: any) {
		commit('setQuestions', payload)
	},
	setPrivacyStatementSelected({ state, commit }, payload: boolean) {
		commit('setPrivacyStatementSelected', payload)
	}
}

export default actions
